
        var normalize = require("../../../node_modules/san-loader/lib/runtime/normalize.js");
        require('/Users/duanhong/Source/Lean/LeanPM/webapps/shared/src/components/Workflow/Workflow.san?lang=less&san=&type=style&index=0');
var injectStyles = [];

        var template = require('./Workflow.html');
        
        var script = require('./Workflow.ts').default;
        module.exports = require('./Workflow.ts');
    
        module.exports.default = normalize(script, template, injectStyles);
        /* san-hmr component */
    